import React from 'react';

import styled from 'styled-components/macro';

const Card = ({ className, children }) => {
  return <div className={className}>{children}</div>;
};

export default styled(Card)`
  background-color: ${props => props.theme.color.white} !important;
  margin: auto;
  box-shadow: 6px 6px 16px 6px rgba(0, 0, 0, 0.33);
  height: 100%;
  display: flex;
`;
